export default "__VITE_ASSET__BXECFODc__"